import React from 'react'
import { Navigate, generatePath } from 'react-router'
import { useConsoleContext } from '../../containers/Console'

interface Props {
  routePath: string
}

export const RouteRedirect: React.FC<Props> = ({ routePath }) => {
  const { navProject } = useConsoleContext() ?? {}
  const pathParts = routePath.split('/')
  const routeParams = {
    projectId: navProject?.id,
  }

  if (pathParts.includes(':projectId') && !routeParams.projectId) {
    return <Navigate to={'/console/profile'} />
  }

  return <Navigate to={generatePath(routePath, routeParams)} />
}
